import React from "react";

/**
 * A mobile contact list item for company's linked contacts.
 */
export default function MobileContactItem({ contact, onClick }) {
  return (
    <div className="mobile-contact-item" onClick={onClick}>
      <div className="mobile-contact-item__name">
        {contact.contact_id?.first_name} {contact.contact_id?.last_name}
      </div>
      <div className="mobile-contact-item__function">
        {contact.function || "No function"}
      </div>
    </div>
  );
}

